const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

/** Wall-clock parts for a date in a given IANA time zone. */
export function zonedParts(date: Date, timeZone: string) {
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone,
    hour: '2-digit',
    minute: '2-digit',
    weekday: 'short',
    day: '2-digit',
    month: 'short',
    hourCycle: 'h23',
    timeZoneName: 'shortOffset',
  }).formatToParts(date);

  const get = (type: Intl.DateTimeFormatPartTypes) => parts.find((p) => p.type === type)?.value ?? '';
  const weekday = get('weekday');
  const offset = get('timeZoneName').replace('GMT', 'UTC') || 'UTC';

  return {
    hours: get('hour'),
    minutes: get('minute'),
    weekday,
    weekdayIndex: WEEKDAYS.indexOf(weekday),
    date: `${get('day')} ${get('month')}`,
    offset: offset === 'UTC' ? 'UTC+0' : offset,
  };
}
